import {
  SET_CLASS_COUNT,
  SET_CLASSES,
  SET_CLASS,
  SET_TRAINER_ATTRIBUTES,
  SET_CLASS_SEARCH
} from '../types/types';

export const setClasses = (value, count) => {
  return {
    type: SET_CLASSES,
    payload: { data: value, count: count },
  };
};

export const setClassCount = (value) => {
  return {
    type: SET_CLASS_COUNT,
    payload: { data: value },
  };
};

export const setClass = (value) => {
  return {
    type: SET_CLASS,
    payload: { data: value },
  };
};
export const setTrainerAttributes = (value) => {
  return {
    type: SET_TRAINER_ATTRIBUTES,
    payload: { data: value },
  };
};

export const setClassSearch = (value) => {
  return {
    type:   SET_CLASS_SEARCH,
    payload: { data: value },
  };
};
